module.exports = __webpack_public_path__ + "static/media/smileCenterHeader.476a86db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smileCenterHeader.png
// module id = 612
// module chunks = 0